/**
 * Created by mac on 2/28/23
 *
 * Scene component for the game scene prefab (res/prefabs/yatzyscene.prefab.json), ported from
 * the YatzyScene that extended the removed GameSceneBase. The game instance is on Game.currentGame.
 */

class YatzySceneComponent extends ScriptComponent {
    onCreate() {
        this.styles = PrefabBuilder.resolveProperty(this.options.styles, this.context);
    }

    onAttach() {
        // Scales the game container into the space left by the up menu.
        this.inflateComponent = ComponentMap.attach(this.node, new InflateComponent({
            getTarget: () => this.container,
            getOptions: () => ({
                maxScale: 1,
                padding: cc.padding(this.styles.padding),
                lovesPosition: cc.p(this.node.x + this.node.width / 2, this.node.y + this.node.height / 2)
            })
        }));
    }

    onReady() {
        const game = Game.currentGame;

        ComponentMap.get(this.node, GameSceneComponent).exclamationView._setGlobalZOrder(true);

        this.container = new cc.Node();
        this.container.setAnchorPoint(0.5, 0.5);

        this.column1 = new cc.Node();
        this.column2 = new cc.Node();

        this.container.addChild(this.column1);
        this.container.addChild(this.column2);

        this.resultsBar = new ResultsBarView();
        this.resultsBar.init(game);
        this.container.addChild(this.resultsBar);

        this.yatzyField = new YatzyFieldView(game);
        this.container.addChild(this.yatzyField);

        this.dicesView = new DicesView(game.dices);
        this.container.addChild(this.dicesView);

        this.rollButton = new RollButtonView(game);
        this.container.addChild(this.rollButton);

        this.node.addChild(this.container);

        this.updateSize();
        this.setupChildren();

        if (cleverapps.likePraise) {
            cleverapps.likePraise.reset(new YatzyLikePraiseAdapter(this.dicesView));
        }

        ComponentUtils.findComponentByName(this.node, "UpMenuController").listNodes()
            .forEach((node) => this.inflateComponent.addAvoidingNode(node, { silent: true }));
        this.inflateComponent.inflate();

        cleverapps.audio.playSound(bundles.game.urls.open_game_scene);
    }

    onAfterResize() {
        this.updateSize();
        this.setupChildren();
        this.inflateComponent.inflate();
    }

    updateSize() {
        if (!this.rollButton) {
            return;
        }

        const styles = cleverapps.styles.YatzyScene;

        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            this.container.setContentSize2(styles.scene.vertical);
        } else {
            this.container.setContentSize2(styles.scene.horizontal);
            this.column1.setContentSize2(this.container.width / 2, this.container.height);
            this.column2.setContentSize2(this.container.width / 2, this.container.height);
        }

        this.container.setScale(1);
        this.container.setPosition(this.node.width / 2, this.node.height / 2);
    }

    setupChildren() {
        if (!this.rollButton) {
            return;
        }

        const styles = cleverapps.styles.YatzyScene;

        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            this.resultsBar.replaceParentSamePlace(this.container);
            this.yatzyField.replaceParentSamePlace(this.container);
            this.dicesView.replaceParentSamePlace(this.container);
            this.rollButton.replaceParentSamePlace(this.container);

            cleverapps.UI.fitToBox(this.yatzyField, this.container);
            cleverapps.UI.fitToBox(this.dicesView, this.container);
            cleverapps.UI.fitToBox(this.resultsBar, this.container);

            this.resultsBar.setAlignment(styles.results.vertical);
            this.yatzyField.setAlignment(styles.field.vertical);
            this.dicesView.setAlignment(styles.dices.vertical);
            this.rollButton.setAlignment(styles.buttons.vertical);
        } else {
            this.column1.setAlignment(0, 0);
            this.column2.setAlignment(this.container.width / 2, 0);

            this.resultsBar.replaceParentSamePlace(this.column2);
            this.yatzyField.replaceParentSamePlace(this.column1);
            this.dicesView.replaceParentSamePlace(this.column2);
            this.rollButton.replaceParentSamePlace(this.column2);

            this.resultsBar.setAlignment(styles.results.horizontal);
            this.yatzyField.setAlignment(styles.field.horizontal);
            cleverapps.UI.fitToBox(this.yatzyField, this.column1);
            cleverapps.UI.fitToBox(this.dicesView, this.column2);
            cleverapps.UI.fitToBox(this.resultsBar, this.column2);

            this.dicesView.setAlignment(styles.dices.horizontal);
            this.rollButton.setAlignment(styles.buttons.horizontal);
        }
    }

    changeGameMode() {
        const game = Game.currentGame;

        this.resultsBar.removeFromParent();
        this.yatzyField.removeFromParent();

        this.resultsBar = new ResultsBarView();
        this.resultsBar.init(game);
        this.container.addChild(this.resultsBar);

        this.yatzyField = new YatzyFieldView(game);
        this.container.addChild(this.yatzyField);

        this.updateSize();
        this.setupChildren();
        this.inflateComponent.inflate();
    }
}

Prefab.registerComponent("YatzySceneComponent", YatzySceneComponent);

GameScene = bundles.main.jsons.yatzyscene_prefab_json;

cleverapps.styles.YatzyScene = {
    scene: {
        horizontal: {
            width: 2050,
            height: 1170
        },
        vertical: {
            width: 550,
            height: 1000
        }
    },

    results: {
        horizontal: {
            x: { align: "center" },
            y: { align: "top", dy: -15 }
        },
        vertical: {
            x: { align: "center" },
            y: { align: "top", dy: 25 }
        }
    },

    field: {
        horizontal: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        },
        vertical: {
            x: { align: "center" },
            y: { align: "center", dy: 95 }
        }
    },

    dices: {
        horizontal: {
            x: { align: "center" },
            y: { align: "center", dy: -25 }
        },
        vertical: {
            x: { align: "center" },
            y: { align: "bottom", dy: 105 }
        }
    },

    buttons: {
        horizontal: {
            x: { align: "center" },
            y: { align: "bottom", dy: 20 }
        },
        vertical: {
            x: { align: "center" },
            y: { align: "bottom", dy: -5 }
        }
    }
};
